import React, { CSSProperties } from 'react';
type OrnamentProps = {
  className?: string;
  color?: string;
  style?: CSSProperties;
};
export function YinYang({
  className = '',
  color = '#b45309',
  style
}: OrnamentProps) {
  return <svg viewBox="0 0 24 24" className={className} style={style} fill="none" stroke={color} strokeWidth="1.3" strokeLinecap="round" aria-hidden="true" data-id="element-104" data-mp="34ylhce0cv4qe">
      <circle cx="12" cy="12" r="9.2" data-id="element-105" data-mp="39vkel5fbfrst" />
      <path d="M12 2.8a4.6 4.6 0 0 0 0 9.2 4.6 4.6 0 0 1 0 9.2" data-id="element-106" data-mp="2d8gtg5ddzzkf" />
      <path d="M12 6.6v.01M12 17.3v.01" data-id="element-107" data-mp="2h991ivaivyf4" />
    </svg>;
}
export function Needle({
  className = '',
  color = '#92400e',
  style
}: OrnamentProps) {
  return <svg viewBox="0 0 24 24" className={className} style={style} fill="none" stroke={color} strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" data-id="element-108" data-mp="2m7kc588n6cye">
      <path d="M20.5 3.5 9 15" data-id="element-109" data-mp="1tkgejobvp0wn" />
      <path d="M17.6 2.2 21.8 6.4" data-id="element-110" data-mp="1tj59ll6p5n3y" />
      <path d="m9 15-2.2 5.4a.7.7 0 0 0 .9.9L13 19" data-id="element-111" data-mp="1yirp619zzffx" />
      <path d="M3.2 20.8 5 19" data-id="element-112" data-mp="1yhgj1ut2xvln" />
    </svg>;
}
export function Bamboo({
  className = '',
  color = '#047857',
  style
}: OrnamentProps) {
  return <svg viewBox="0 0 24 24" className={className} style={style} fill="none" stroke={color} strokeWidth="1.35" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" data-id="element-113" data-mp="31vv91vzrwmuq">
      <path d="M9 22V2M9 7h3M9 13h3M9 18h3" data-id="element-114" data-mp="2x3bsqr9pbdm8" />
      <path d="M12 9c3.4-.6 5.6-2.4 6.6-5-3.2-.4-5.6 1.2-6.6 5Z" data-id="element-115" data-mp="2s6liwlohpe99" />
      <path d="M12 16c3.2-.3 5.4 1 6.6 3.4-3.2.7-5.6-.3-6.6-3.4Z" data-id="element-116" data-mp="2s490k7etl1vo" />
    </svg>;
}
export function Mandala({
  className = '',
  color = '#b45309',
  style
}: OrnamentProps) {
  return <svg viewBox="0 0 100 100" className={className} style={style} fill="none" stroke={color} strokeWidth="1" aria-hidden="true" data-id="element-117" data-mp="2i6ksygw47zw3">
      <circle cx="50" cy="50" r="44" data-id="element-118" data-mp="2977jvpbwldbw" />
      <circle cx="50" cy="50" r="30" data-id="element-119" data-mp="298952mmmvg7c" />
      <circle cx="50" cy="50" r="12" data-id="element-120" data-mp="299ak126rsmuc" />
      <path d="M50 6v88M6 50h88M18.9 18.9l62.2 62.2M81.1 18.9 18.9 81.1" data-id="element-121" data-mp="cfh344ray63f" />
      <path d="M50 20c10 9 10 21 0 30-10-9-10-21 0-30ZM50 50c10 9 10 21 0 30-10-9-10-21 0-30ZM20 50c9-10 21-10 30 0-9 10-21 10-30 0ZM50 50c9-10 21-10 30 0-9 10-21 10-30 0Z" data-id="element-122" data-mp="7furfzr4gxwq" />
    </svg>;
}
type SealProps = {
  characters?: string;
  className?: string;
};
export function Seal({
  characters = '針灸',
  className = ''
}: SealProps) {
  return <span className={`inline-flex h-11 w-11 shrink-0 items-center justify-center rounded-md bg-red-700 p-1 text-center text-[13px] font-bold leading-[1.05] text-white shadow-sm ${className}`} aria-hidden="true" data-id="element-123" data-mp="hkkn5nvxn5si">
      {characters}
    </span>;
}
type KanjiBackdropProps = {
  glyphs?: string[];
  className?: string;
};

/** Decorative column of oversized Chinese characters behind a section. */
export function KanjiBackdrop({
  glyphs = ['氣', '經', '絡', '陰', '陽'],
  className = ''
}: KanjiBackdropProps) {
  return <div className={`pointer-events-none absolute inset-0 -z-10 overflow-hidden ${className}`} aria-hidden="true" data-id="element-124" data-mp="1582hnr6l0hz6">
      <div className="absolute -left-4 top-6 flex flex-col gap-10 text-[5rem] leading-none text-stone-900/[0.05] md:text-[8rem]" data-id="element-125" data-mp="3kyx54dv956w5">
        {glyphs.slice(0, 3).map((glyph, index) => <span key={`${glyph}-${index}`} data-id="element-126" data-mp="3if0qdrjuzjk8" data-mpi={index}>{glyph}</span>)}
      </div>
      <div className="absolute -right-4 bottom-6 flex flex-col gap-10 text-[5rem] leading-none text-stone-900/[0.05] md:text-[8rem]" data-id="element-127" data-mp="3dgz5r26sbc6n">
        {glyphs.slice(3).map((glyph, index) => <span key={`${glyph}-${index}`} data-id="element-128" data-mp="3rens6egi2rdt" data-mpi={index}>{glyph}</span>)}
      </div>
    </div>;
}

/** Thin hairline divider with an optional centered character. */
export function FretDivider({
  character = '氣',
  className = ''
}: {
  character?: string;
  className?: string;
}) {
  return <div className={`flex items-center justify-center gap-4 ${className}`} aria-hidden="true" data-id="element-129" data-mp="2ursjj56s82g3">
      <span className="h-px w-20 bg-stone-300 sm:w-32" data-id="element-130" data-mp="38inzt2jm1ltp" />
      <span className="text-lg text-amber-700/70" data-id="element-131" data-mp="33rfog0ypzqdw">
        {character}
      </span>
      <span className="h-px w-20 bg-stone-300 sm:w-32" data-id="element-132" data-mp="33pcnwmzxyeux" />
    </div>;
}